

export const mangeContents=[
  {
    name:'Courses',
    to:'courses'
  },
  {
    name:'Categories',
    to:'Categories'
  },
  {
    name:'Levels',
    to:'Levels'
  },
  {
    name:'Course Review',
    to:'Course-Review'
  },
] 
export const mangeBlogs=[
  {
    name:'Category list',
    to:'Blogs-Category'
  },
  {
    name:'Post list',
    to:'post-list'
  },
  {
    name:'Post comments',
    to:'Post-comments'
  },
]
export const mangeOrders=[
  {
    name:'Order history',
    to:'order-history'
  },
  {
    name:'Pending payment',
    to:'Pending-payment'
  },

]
export const mangeUsers=[
  {
    name:'All students',
    to:'All-students'
  },
  // {
  //   name:'Instructors',
  //   to:'Instructors'
  // },
  {
    name:'Active users',
    to:'Active-users'
  },
  {
    name:'Non verified',
    to:'Non-verified'
  },
  {
    name:'Banned users',
    to:'Banned-users'
  },
  {
    name:'Send bulk mail',
    to:'Send-bulk-mail'
  },

]
export const withdraw = [
  {
    name:'Withdraw Method',
    to:'withdraw-method'
  },
  {
    name:'Withdraw Request',
    to:'withdraw-request'
  }
]